// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibEffectBuildersChunk0() {

    // @TypeExtensions(AdsrBuilder::class) on AdsrBuilder
    registerExtensionMethodWithSpecs(
        receiver = AdsrBuilder::class,
        name = "curves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(AdsrBuilder::class, loc)
        checkArgsSize(fn = "curves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
            )
        )
    }

    // @TypeExtensions(AdsrBuilder::class) on AdsrBuilder
    registerExtensionMethodWithSpecs(
        receiver = AdsrBuilder::class,
        name = "declick",
        paramSpecs = listOf(
            ParamSpec(name = "seconds", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(AdsrBuilder::class, loc)
        checkArgsSize(fn = "declick", args = args, expected = 1, location = loc)
        val seconds = convertArgToKotlin(fn = "declick", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDeclick(seconds = seconds))
    }

    // @TypeExtensions(ModAdsrBuilder::class) on ModAdsrBuilder
    registerExtensionMethodWithSpecs(
        receiver = ModAdsrBuilder::class,
        name = "curves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(ModAdsrBuilder::class, loc)
        checkArgsSize(fn = "curves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
            )
        )
    }

    // @TypeExtensions(FilterBuilder::class) on FilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = FilterBuilder::class,
        name = "passes",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FilterBuilder::class, loc)
        checkArgsSize(fn = "passes", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "passes", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPasses(n = n))
    }

    // @TypeExtensions(FilterBuilder::class) on FilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = FilterBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FilterBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(FilterBuilder::class) on FilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = FilterBuilder::class,
        name = "humanize",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(true) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FilterBuilder::class, loc)
        checkArgsSize(fn = "humanize", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptHumanize(
                on = if (args.size > 0) convertArgToKotlin(fn = "humanize", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else true,
            )
        )
    }

    // @TypeExtensions(FilterBuilder::class) on FilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = FilterBuilder::class,
        name = "env",
        paramSpecs = listOf(
            ParamSpec(name = "semitones", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FilterBuilder::class, loc)
        checkArgsSize(fn = "env", args = args, expected = 1, location = loc)
        val semitones = convertArgToKotlin(fn = "env", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptEnv(semitones = semitones))
    }

    // @TypeExtensions(FilterBuilder::class) on FilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = FilterBuilder::class,
        name = "adsr",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class),
            ParamSpec(name = "decay", kotlinType = Any::class),
            ParamSpec(name = "sustain", kotlinType = Any::class),
            ParamSpec(name = "release", kotlinType = Any::class),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FilterBuilder::class, loc)
        checkArgsSize(fn = "adsr", args = args, expected = 4, location = loc)
        val attack = convertArgToKotlin(fn = "adsr", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val decay = convertArgToKotlin(fn = "adsr", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        val sustain = convertArgToKotlin(fn = "adsr", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
        val release = convertArgToKotlin(fn = "adsr", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptAdsr(
                attack = attack,
                decay = decay,
                sustain = sustain,
                release = release,
                configure = optArg(args, 4, Function1::class, loc) as ((ModAdsrBuilder) -> ModAdsrBuilder)?,
            )
        )
    }

    // @TypeExtensions(BandFilterBuilder::class) on BandFilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = BandFilterBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(BandFilterBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(BandFilterBuilder::class) on BandFilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = BandFilterBuilder::class,
        name = "humanize",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(true) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(BandFilterBuilder::class, loc)
        checkArgsSize(fn = "humanize", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptHumanize(
                on = if (args.size > 0) convertArgToKotlin(fn = "humanize", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else true,
            )
        )
    }

    // @TypeExtensions(BandFilterBuilder::class) on BandFilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = BandFilterBuilder::class,
        name = "env",
        paramSpecs = listOf(
            ParamSpec(name = "semitones", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(BandFilterBuilder::class, loc)
        checkArgsSize(fn = "env", args = args, expected = 1, location = loc)
        val semitones = convertArgToKotlin(fn = "env", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptEnv(semitones = semitones))
    }

    // @TypeExtensions(BandFilterBuilder::class) on BandFilterBuilder
    registerExtensionMethodWithSpecs(
        receiver = BandFilterBuilder::class,
        name = "adsr",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class),
            ParamSpec(name = "decay", kotlinType = Any::class),
            ParamSpec(name = "sustain", kotlinType = Any::class),
            ParamSpec(name = "release", kotlinType = Any::class),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(BandFilterBuilder::class, loc)
        checkArgsSize(fn = "adsr", args = args, expected = 4, location = loc)
        val attack = convertArgToKotlin(fn = "adsr", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val decay = convertArgToKotlin(fn = "adsr", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        val sustain = convertArgToKotlin(fn = "adsr", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
        val release = convertArgToKotlin(fn = "adsr", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptAdsr(
                attack = attack,
                decay = decay,
                sustain = sustain,
                release = release,
                configure = optArg(args, 4, Function1::class, loc) as ((ModAdsrBuilder) -> ModAdsrBuilder)?,
            )
        )
    }

    // @TypeExtensions(PitchEnvelopeBuilder::class) on PitchEnvelopeBuilder
    registerExtensionMethodWithSpecs(
        receiver = PitchEnvelopeBuilder::class,
        name = "adsr",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class),
            ParamSpec(name = "decay", kotlinType = Any::class),
            ParamSpec(name = "sustain", kotlinType = Any::class),
            ParamSpec(name = "release", kotlinType = Any::class),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PitchEnvelopeBuilder::class, loc)
        checkArgsSize(fn = "adsr", args = args, expected = 4, location = loc)
        val attack = convertArgToKotlin(fn = "adsr", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val decay = convertArgToKotlin(fn = "adsr", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        val sustain = convertArgToKotlin(fn = "adsr", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
        val release = convertArgToKotlin(fn = "adsr", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptAdsr(
                attack = attack,
                decay = decay,
                sustain = sustain,
                release = release,
                configure = optArg(args, 4, Function1::class, loc) as ((ModAdsrBuilder) -> ModAdsrBuilder)?,
            )
        )
    }

    // @TypeExtensions(FmBuilder::class) on FmBuilder
    registerExtensionMethodWithSpecs(
        receiver = FmBuilder::class,
        name = "adsr",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class),
            ParamSpec(name = "decay", kotlinType = Any::class),
            ParamSpec(name = "sustain", kotlinType = Any::class),
            ParamSpec(name = "release", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(FmBuilder::class, loc)
        checkArgsSize(fn = "adsr", args = args, expected = 4, location = loc)
        val attack = convertArgToKotlin(fn = "adsr", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val decay = convertArgToKotlin(fn = "adsr", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        val sustain = convertArgToKotlin(fn = "adsr", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
        val release = convertArgToKotlin(fn = "adsr", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAdsr(attack = attack, decay = decay, sustain = sustain, release = release))
    }

    // @TypeExtensions(EqBuilder::class) on EqBuilder
    registerExtensionMethodWithSpecs(
        receiver = EqBuilder::class,
        name = "band",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class),
            ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
            ParamSpec(name = "db", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(EqBuilder::class, loc)
        checkArgsSize(fn = "band", args = args, expected = 1, location = loc)
        val freq = convertArgToKotlin(fn = "band", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptBand(
                freq = freq,
                q = if (args.size > 1) convertArgToKotlin(fn = "band", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                db = if (args.size > 2) convertArgToKotlin(fn = "band", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
            )
        )
    }

    // @TypeExtensions(EqBuilder::class) on EqBuilder
    registerExtensionMethodWithSpecs(
        receiver = EqBuilder::class,
        name = "tap",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class),
            ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
            ParamSpec(name = "gain", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(EqBuilder::class, loc)
        checkArgsSize(fn = "tap", args = args, expected = 1, location = loc)
        val freq = convertArgToKotlin(fn = "tap", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptTap(
                freq = freq,
                q = if (args.size > 1) convertArgToKotlin(fn = "tap", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                gain = if (args.size > 2) convertArgToKotlin(fn = "tap", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(KatalystEqBuilder::class) on KatalystEqBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystEqBuilder::class,
        name = "band",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class),
            ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
            ParamSpec(name = "db", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystEqBuilder::class, loc)
        checkArgsSize(fn = "band", args = args, expected = 1, location = loc)
        val freq = convertArgToKotlin(fn = "band", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptBand(
                freq = freq,
                q = if (args.size > 1) convertArgToKotlin(fn = "band", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                db = if (args.size > 2) convertArgToKotlin(fn = "band", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibEffectBuildersChunk1() {

    // @TypeExtensions(KatalystEqBuilder::class) on KatalystEqBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystEqBuilder::class,
        name = "tap",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class),
            ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
            ParamSpec(name = "gain", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystEqBuilder::class, loc)
        checkArgsSize(fn = "tap", args = args, expected = 1, location = loc)
        val freq = convertArgToKotlin(fn = "tap", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptTap(
                freq = freq,
                q = if (args.size > 1) convertArgToKotlin(fn = "tap", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                gain = if (args.size > 2) convertArgToKotlin(fn = "tap", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(PhaserBuilder::class) on PhaserBuilder
    registerExtensionMethodWithSpecs(
        receiver = PhaserBuilder::class,
        name = "floor",
        paramSpecs = listOf(
            ParamSpec(name = "floor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PhaserBuilder::class, loc)
        checkArgsSize(fn = "floor", args = args, expected = 1, location = loc)
        val floor = convertArgToKotlin(fn = "floor", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFloor(floor = floor))
    }

    // @TypeExtensions(TremoloBuilder::class) on TremoloBuilder
    registerExtensionMethodWithSpecs(
        receiver = TremoloBuilder::class,
        name = "range",
        paramSpecs = listOf(
            ParamSpec(name = "from", kotlinType = Any::class),
            ParamSpec(name = "to", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(TremoloBuilder::class, loc)
        checkArgsSize(fn = "range", args = args, expected = 2, location = loc)
        val from = convertArgToKotlin(fn = "range", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val to = convertArgToKotlin(fn = "range", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptRange(from = from, to = to))
    }

    // @TypeExtensions(TremoloBuilder::class) on TremoloBuilder
    registerExtensionMethodWithSpecs(
        receiver = TremoloBuilder::class,
        name = "shape",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(TremoloBuilder::class, loc)
        checkArgsSize(fn = "shape", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "shape", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptShape(name = name))
    }

    // @TypeExtensions(VibratoBuilder::class) on VibratoBuilder
    registerExtensionMethodWithSpecs(
        receiver = VibratoBuilder::class,
        name = "range",
        paramSpecs = listOf(
            ParamSpec(name = "from", kotlinType = Any::class),
            ParamSpec(name = "to", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(VibratoBuilder::class, loc)
        checkArgsSize(fn = "range", args = args, expected = 2, location = loc)
        val from = convertArgToKotlin(fn = "range", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val to = convertArgToKotlin(fn = "range", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptRange(from = from, to = to))
    }

    // @TypeExtensions(VibratoBuilder::class) on VibratoBuilder
    registerExtensionMethodWithSpecs(
        receiver = VibratoBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(VibratoBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(ShimmerBuilder::class) on ShimmerBuilder
    registerExtensionMethodWithSpecs(
        receiver = ShimmerBuilder::class,
        name = "floor",
        paramSpecs = listOf(
            ParamSpec(name = "floor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(ShimmerBuilder::class, loc)
        checkArgsSize(fn = "floor", args = args, expected = 1, location = loc)
        val floor = convertArgToKotlin(fn = "floor", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFloor(floor = floor))
    }
}

